import { APIGetFuelPolicies } from '../../config/restAPI/FetchAPI';
import { parseFuelPoliciesListResponse } from '../../panel/inventory/fuelConfigurator/fuelPolicyApiMapping';
import { findFuelPolicyRecordById } from '../../panel/inventory/vehicleConfigurator/fuelPolicyGnssMapping';
import { resolveFuelPolicyIdFromPreset } from '../../panel/inventory/vehicleConfigurator/vehiclePolicyConfig';

const policyCacheByAgency = new Map();
const CACHE_TTL_MS = 60_000;

async function getFuelPoliciesForAgency(token, agencyId) {
    const cached = policyCacheByAgency.get(agencyId);
    if (cached && Date.now() - cached.fetchedAt < CACHE_TTL_MS) {
        return cached.policies;
    }

    const noopSetLoading = () => {};
    const result = await APIGetFuelPolicies(noopSetLoading, token, agencyId, {
        pageNumber: 1,
        totalPerPage: 500,
    });
    const { policies } = parseFuelPoliciesListResponse(result);
    const list = Array.isArray(policies) ? policies : [];
    policyCacheByAgency.set(agencyId, { policies: list, fetchedAt: Date.now() });
    return list;
}

/** Resolve fuel policy from device `vehiclePreset.hardwarePolicy` bindings. */
export async function fetchFuelPolicyForVehiclePreset(token, agencyId, vehiclePreset) {
    const policyId = resolveFuelPolicyIdFromPreset(vehiclePreset);
    if (!policyId) {
        return null;
    }

    try {
        const policies = await getFuelPoliciesForAgency(token, agencyId);
        return findFuelPolicyRecordById(policies, policyId);
    } catch (err) {
        return null;
    }
}
